<!--
     ExplorerDirectoryPath shows a single path

     USAGE:
     <ExplorerDirectoryPath
       :path="activeDirectory.path"
     ></ExplorerDirectoryPath>
-->

<template>
  <span
    v-if="path"
  >
    <span
      v-for="dir in path"
      :key="dir.id">
      <span
        v-if="dir.path.length > 1"
      >
        &gt;
      </span>
      <span style="display: inline-block" class="text-start">
        <v-icon :color="dir.color">
          mdi-folder
        </v-icon>
        {{ dir.name }}
      </span>
    </span>
  </span>
</template>


<script>
 export default {
   name: 'ExplorerDirectoryPath',
   props: ['path'],
   data: () => ({}),
 }
</script>
<style lang="scss">
    @import "@/sass/explorer.scss";
</style>